export default `blog-toc-title = この記事では

`;